module.exports = __webpack_public_path__ + "/img/Oscillator-JLead-dxGAkv.svg";